import { Monitor, Moon, Sun, type LucideIcon } from "lucide-react";

import type { Theme } from "@/contexts/theme";

/** Opciones de tema en orden de presentación; las comparten todos los selectores. */
export const THEME_OPTIONS: { value: Theme; label: string; icon: LucideIcon }[] = [
  { value: "light", label: "Claro", icon: Sun },
  { value: "dark", label: "Oscuro", icon: Moon },
  { value: "system", label: "Sistema", icon: Monitor },
];
